import React from "react";

const GiphyContext = React.createContext({});

export default GiphyContext;
